var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(item){return _c('span',{key:item.id,on:{"click":function($event){return _vm.onShare(item)}}},[_vm._v(_vm._s(item.text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }